"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M17.3452 13.2426C17.7352 12.3982 18 11.3558 18 10c0-3.0461-2.4182-6-6-6-1.1733 0-2.226.3043-3.1077.7871l1.5033 1.5038C10.8757 6.1082 11.4142 6 12 6c2.3682 0 4 1.9461 4 4 0 .6826-.0705 1.233-.197 1.6999l1.5422 1.5427z"
  }), _react.default.createElement("path", {
    d: "m14.0518 9.9482.6553-.6553-.7724-.7724a3.1144 3.1144 0 0 0-2.2231-.9132l2.3402 2.341zM3.358 2 2 3.3568l6.6873 6.6894a3.1094 3.1094 0 0 0 .2543 2.0731c.3497.6993.4527 1.5655-.3888 1.9863l.8944 1.7888c1.3855-.6927 1.8919-2.0486 1.6896-3.398l2.4335 2.4343c-.1219.1473-.2456.303-.3703.4693-.325.4333-.5995.8986-.8739 1.3637-.2578.437-.5155.8739-.815 1.2841-.487.667-.9065.9522-1.5111.9522-.9896 0-2-.9825-2-2H6c0 2.1055 1.9227 4 4 4 1.5204 0 2.4634-.8648 3.1264-1.7728.2972-.4071.5529-.8413.8085-1.2755.2718-.4615.5435-.9229.8651-1.3517a6.4344 6.4344 0 0 1 .194-.2452l5.6477 5.6495 1.3581-1.3568L3.358 2z"
  })];
};

exports.default = _default;